import React from 'react';
import { Button } from './Button';
export const FeatureSection = () => {
  const checkoutUrl = 'https://www.neurotoned.com/offers/6oqdjPAT?coupon_code=7DAYRESETSPECIAL2025';
  return <section className="bg-gradient-to-b from-teal-800 to-teal-700 text-white py-16" data-id="element-120">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-121">
        <h2 className="text-3xl md:text-4xl font-bold mb-6 text-center" data-id="element-122">
          What Makes Neurotoned Different?
        </h2>
        <div className="mb-8 max-w-2xl mx-auto" data-id="element-123">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rSMrSVPRFdj5k4GtioQZz3/4ca5dd5-d0c-e0c-caff-b437eefd381_Untitled_design.jpg" alt="Nervous system illustration" className="w-full rounded-lg shadow-xl" data-id="element-124" />
        </div>
        <h3 className="text-2xl font-semibold mb-4 text-center" data-id="element-125">
          This isn't mindset work. This isn't therapy. This isn't an app.
        </h3>
        <div className="mb-10 space-y-6" data-id="element-126">
          <p className="text-lg" data-id="element-127">
            This is <em data-id="element-128">not</em> Calm, Headspace, Apollo Neuro, or another
            tech-based hack.
          </p>
          <p className="text-lg text-center mb-8" data-id="element-129">
            It's a structured, 7-Day Guided Reset you can access from any
            device, rooted in:
          </p>
          <ul className="list-disc pl-6 space-y-3 mb-8" data-id="element-130">
            <li data-id="element-131">Trauma-informed yoga</li>
            <li data-id="element-132">Somatic experiencing techniques</li>
            <li data-id="element-133">Polyvagal theory (applied, not theoretical)</li>
            <li data-id="element-134">Expressive arts + guided movement</li>
            <li data-id="element-135">Grounded science</li>
          </ul>
          <div className="bg-white bg-opacity-10 p-6 rounded-lg italic" data-id="element-136">
            <p data-id="element-137">
              Designed by a Doctor of Behavioral Health with 20+ years of
              experience in trauma therapy and nervous system repair.
            </p>
          </div>
        </div>
        <p className="text-center text-lg mb-6" data-id="element-138">
          Already Know The Science? Now You'll Feel the Shift — With Just One
          Week of Daily Body-Based Practice.
        </p>
        <div className="flex justify-center" data-id="element-139">
          <Button link={checkoutUrl} data-id="element-140">Try the 7-Day Reset – Just $9 ➔</Button>
        </div>
      </div>
    </section>;
};